// extracted by mini-css-extract-plugin
export default {"mainContainer":"StatBar_mainContainer__U2yJB","percentageBarContainer":"StatBar_percentageBarContainer__UbYje","percentageBar":"StatBar_percentageBar__ZXpy3"};